import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { BehaviorSubject, firstValueFrom } from 'rxjs';
import { Router } from '@angular/router';

export interface RemoteDocument {
  downloadURL: string;
  id: 'passport' | 'certificate';
}

export interface UserProfile {
  user_id?: string;
  image_url?: string;
  first_name?: string;
  push_token?: string;
  last_name?: string;
  avatar?: string;
  email?: string;
  tel?: string;
  street?: string;
  postal?: string;
  city?: string;
  nationality?: string;
  gender?: string;
  iban?: string;
  docs?: RemoteDocument[];
  level?: number;
  verified?: boolean;
  parent_user_id?: string;
  parent?: {
    user_id?: string;
    first_name?: string;
    last_name?: string;
    name?: string;
    email?: string;
  };
  levels?: {
    current_level?: string;
    next_level?: number;
    required_signatures?: number;
    current_signatures?: number;
    total_required_signatures?: number;
  };
}

@Injectable({
  providedIn: 'root',
})
export class ProfileDataService {
  private userProfile: BehaviorSubject<UserProfile> =
    new BehaviorSubject<UserProfile>({});

  constructor(private _http: HttpClient,
    private _router: Router
  ) {
    this.loadUserDetails();
  }

  async updateProfile(profile: UserProfile) {
    try {
      await firstValueFrom(
        this._http.put(`${environment.apiUrl}/regional/users`, profile),
      );
      this.userProfile.next({ ...this.userProfile.getValue(), ...profile });
    } catch (error) {
      throw new Error('Konnte Profil nicht aktualisieren.');
    }
  }

  async loadUserDetails() {
    try {
      const result = await firstValueFrom(
        this._http.get<UserProfile>(`${environment.apiUrl}/regional/users/details`),
      );
      this.userProfile.next(result);
    } catch (error: any) {
      if (error.status == 404) {
        this._router.navigate(['/auth/onboarding']);
      }
    }
  }

  getUserProfile() {
    const profile = { ...this.userProfile.getValue() };
    if (!profile.image_url) {
      profile.image_url = '/assets/images/default-avatar.jpg';
    }
    return profile;
  }

  getUserProfileObservable() {
    return this.userProfile.asObservable();
  }

  async leaveParentRegionalHub() {
    try {
      await firstValueFrom(
        this._http.post(`${environment.apiUrl}/regional/invitation/leave-parent`, {})
      );
      // Reload user details to update the profile
      await this.loadUserDetails();
    } catch (error: any) {
      throw new Error(error.error?.error || 'Fehler beim Verlassen des Stamm-Hubs.');
    }
  }
}